/* 🤖 this file was generated by svg-to-ts */
export const matIconEject: {
  name: 'eject';
  data: string;
} = {
  name: 'eject',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6 2.93 4.4H9.07L12 8.6z"/></svg>`
};
